
/***
 *
 * @type {string}
 */

export const FUNCTION = 'function';
export const STRING = 'string';
export const OBJECT = 'object';

export const TYPES = {
    FUNCTION: 'function',
    STRING: 'string',
    OBJECT: 'object',
    NUMBER: 'number'
};

